var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartlead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.0371,
    height: 41.0371,
    viewBox: "-2.0 -2.0 41.0371 41.0371",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.6605C0 2.08658 2.08658 0 4.6605 0H32.3766C34.9505 0 37.0371 2.08658 37.0371 4.6605V32.3766C37.0371 34.9505 34.9505 37.0371 32.3766 37.0371H4.6605C2.08658 37.0371 0 34.9505 0 32.3766V4.6605Z",
    fill: "#6E58F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34961 15.6713C5.34961 12.4766 7.92959 9.88672 11.1122 9.88672H11.4436C12.7898 9.88672 13.8812 10.9822 13.8812 12.3336V19.009C13.8812 20.3604 12.7898 21.4559 11.4436 21.4559H11.1121C7.92958 21.4559 5.34961 18.8661 5.34961 15.6713Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1885 10.8997C15.1885 10.2793 15.5515 9.71677 16.1155 9.4631L24.5041 5.69018C25.5416 5.22354 26.7136 5.98556 26.7136 7.12683V24.3238C26.7136 25.4724 25.5278 26.2343 24.4887 25.7534L16.1001 21.8712C15.5444 21.614 15.1885 21.0558 15.1885 20.4415V19.6454C15.1885 18.9904 15.5925 18.4039 16.2029 18.1726L20.8784 16.4011C21.5547 16.1448 21.5547 15.1845 20.8784 14.9282L16.2029 13.1567C15.5925 12.9254 15.1885 12.3389 15.1885 11.6839V10.8997Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6876 17.0361V16.6855C31.6876 14.7493 30.124 13.1797 28.1951 13.1797C28.0987 13.1797 28.0205 13.2582 28.0205 13.355V20.3666C28.0205 20.4634 28.0987 20.5419 28.1951 20.5419C30.124 20.5419 31.6876 18.9723 31.6876 17.0361Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0996 23.6858C11.0996 23.3415 11.3776 23.0625 11.7205 23.0625H14.969C15.3119 23.0625 15.5899 23.3415 15.5899 23.6858V29.2227C15.5899 30.4674 14.5847 31.4765 13.3448 31.4765L-nan -nanL13.3448 31.4765C12.1048 31.4765 11.0996 30.4674 11.0996 29.2227V23.6858Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartlead);
export default __webpack_public_path__ + "static/media/smartlead.88a8c5b8e72c24d59bce05e376d2848d.svg";
export { ForwardRef as ReactComponent };